<template>
  <div class="page-container">
    <Header />
    <div
      class="top media-wrapper"
      :style="{ height: calculatedTopHeight + 'px' }"
    >
      <div class="info">
        <span class="main-title">Trans-PET</span>
        <span class="sub-title">{{ $t("trans_pet") }}</span>
      </div>
    </div>
    <div class="part-01 part-01-margin">
      <img
        src="@/assets/images/pet/R.png"
        alt=""
        class="right-big-img mobile-hide"
      />
      <div class="part-container media-container">
        <img
          src="@/assets/images/pet/02.png"
          alt=""
          class="left-big-img left-big-img-top-right"
        />
        <div class="part-left">
          <div class="item white">
            <span class="item-name">{{ $t("high_throughput") }}</span>
            <span class="item-desc">{{ $t("high_throughput_desc1") }}</span>
            <span class="item-desc">{{ $t("high_throughput_desc2") }}</span>
          </div>
        </div>
        <div class="part-right">
          <div class="item-row">
            <div class="item white">
              <span class="item-name">{{ $t("multimodal_imaging") }}</span>
              <span class="item-desc">{{ $t("multimodal_desc1") }}</span>
              <span class="item-desc">{{ $t("multimodal_desc2") }}</span>
              <span class="item-desc">{{ $t("multimodal_desc3") }}</span>
            </div>
            <div class="item red">
              <span class="item-name">{{
                $t("feature_dynamic_static_imaging")
              }}</span>
              <span class="item-desc">{{
                $t("feature_drug_metabolism_monitor")
              }}</span>
              <span class="item-desc">{{
                $t("feature_high_resolution_static")
              }}</span>
              <span class="item-desc">{{ $t("feature_multi_scenario") }}</span>
            </div>
            <div class="tag tag-float">{{ $t("core_features") }}</div>
          </div>
          <div class="item-row">
            <div class="item red">
              <span class="item-name">{{ $t("flexible_expansion") }}</span>
              <span class="item-desc">{{ $t("flexible_desc1") }}</span>
              <span class="item-desc">{{ $t("flexible_desc2") }}</span>
              <span class="item-desc">{{ $t("flexible_desc3") }}</span>
            </div>
          </div>
          <div class="item-row">
            <div class="item gray">
              <span class="item-name">{{ $t("offline_data_optimize") }}</span>
              <span class="item-desc">{{ $t("offline_desc1") }}</span>
              <span class="item-desc">{{ $t("offline_desc2") }}</span>
              <span class="item-desc">{{ $t("offline_desc3") }}</span>
            </div>
            <div class="item white">
              <span class="item-name">{{ $t("custom_algorithm") }}</span>
              <span class="item-desc">{{ $t("custom_algo_desc1") }}</span>
              <span class="item-desc">{{ $t("custom_algo_desc2") }}</span>
              <span class="item-desc">{{ $t("custom_algo_desc3") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part-02">
      <div class="part-container media-container part-02-container">
        <div class="part-item">
          <div class="item-row part-02-row">
            <div class="tag tag-inline">{{ $t("performance") }}</div>
            <div class="item white">
              <span class="item-name">20cm × 16cm</span>
              <span class="item-desc">AFOV × TFOV</span>
            </div>
            <div class="item white">
              <span class="item-name">7.6% (350-650keV)</span>
              <span class="item-desc">Sensitivity</span>
            </div>
            <div class="item white">
              <span class="item-name">1540 kcps @ 129MBq</span>
              <span class="item-desc">NECR</span>
            </div>
            <div class="item white">
              <span class="item-name">0.1MBq-120MBq</span>
              <span class="item-desc">Activity dynamic range</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part-03">
      <div class="part-container left-wrapper part-03-container">
        <div class="part-left part-03-left">
          <img src="@/assets/images/pet/01.png" alt="" class="part-03-img" />
        </div>
        <div class="part-right part-03-right">
          <div class="item-row">
            <div class="item red">
              <span class="item-name">{{ $t("basic_research") }}</span>
              <span class="item-desc">{{ $t("cardiology") }}</span>
              <span class="item-desc">{{ $t("oncological_imaging") }}</span>
              <span class="item-desc">{{ $t("neuroscience") }}</span>
              <span class="item-desc">{{ $t("immunoimaging") }}</span>
            </div>
            <div class="item white">
              <span class="item-name">{{ $t("drug_development") }}</span>
              <span class="item-desc">{{ $t("pharmacokinetics") }}</span>
              <span class="item-desc">{{ $t("pharmacodynamic_eval") }}</span>
              <span class="item-desc">{{ $t("drug_safety") }}</span>
            </div>
            <div class="tag tag-float">{{ $t("application_areas") }}</div>
          </div>
          <div class="item-row">
            <div class="item gray">
              <span class="item-name">{{ $t("veterinary_medicine") }}</span>
              <span class="item-desc">{{ $t("vet_exam") }}</span>
              <span class="item-desc">{{ $t("tumor_detection") }}</span>
              <span class="item-desc">{{ $t("treatment_plan") }}</span>
              <span class="item-desc">{{ $t("efficacy_eval") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part-04">
      <div class="part-container right-wrapper part-04-container">
        <div class="tag">{{ $t("application_imaging") }}</div>
        <button class="nav-button left-button" @click="scrollLeft">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="20" cy="20" r="20" fill="#85061B" fill-opacity="0.8" />
            <path
              d="M25 20L15 20M15 20L20 15M15 20L20 25"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <div class="scroll-container">
          <div class="scroll-content" ref="scrollContainer">
            <div class="item white">
              <img src="@/assets/images/pet/06.png" alt="" />
              <div class="text-content">
                <span class="item-name">{{ $t("case_tumor") }}</span>
                <span class="item-desc">{{ $t("case_tumor_desc") }}</span>
                <span class="item-desc">{{ $t("case_tumor_ref") }}</span>
              </div>
            </div>
            <div class="item white">
              <img src="@/assets/images/pet/07.png" alt="" />
              <div class="text-content">
                <span class="item-name">{{ $t("case_colon_cancer") }}</span>
                <span class="item-desc">{{
                  $t("case_colon_cancer_desc")
                }}</span>
                <span class="item-desc">{{ $t("case_colon_cancer_ref") }}</span>
              </div>
            </div>
            <div class="item white">
              <img src="@/assets/images/pet/08.png" alt="" />
              <div class="text-content">
                <span class="item-name">{{ $t("case_dementia") }}</span>
                <span class="item-desc">{{ $t("case_dementia_desc") }}</span>
                <span class="item-desc">{{ $t("case_dementia_ref") }}</span>
              </div>
            </div>
            <div class="item white">
              <img src="@/assets/images/pet/09.png" alt="" />
              <div class="text-content">
                <span class="item-name">{{ $t("case_depression") }}</span>
                <span class="item-desc">{{ $t("case_depression_desc") }}</span>
                <span class="item-desc">{{ $t("case_depression_ref") }}</span>
              </div>
            </div>
            <div class="item white">
              <img src="@/assets/images/pet/10.png" alt="" />
              <div class="text-content">
                <span class="item-name">{{
                  $t("case_myocardial_infarction")
                }}</span>
                <span class="item-desc">{{
                  $t("case_myocardial_infarction_desc")
                }}</span>
                <span class="item-desc">{{
                  $t("case_myocardial_infarction_ref")
                }}</span>
              </div>
            </div>
            <div class="item white">
              <img src="@/assets/images/pet/11.png" alt="" />
              <div class="text-content">
                <span class="item-name">{{ $t("case_ischemic_heart") }}</span>
                <span class="item-desc">{{
                  $t("case_ischemic_heart_desc")
                }}</span>
                <span class="item-desc">{{
                  $t("case_ischemic_heart_ref")
                }}</span>
              </div>
            </div>
            <div class="item white">
              <img src="@/assets/images/pet/12.png" alt="" />
              <div class="text-content">
                <span class="item-name">{{ $t("case_brain_metabolism") }}</span>
                <span class="item-desc">{{
                  $t("case_brain_metabolism_desc")
                }}</span>
                <span class="item-desc">{{
                  $t("case_brain_metabolism_ref")
                }}</span>
              </div>
            </div>
            <div class="item white">
              <img src="@/assets/images/pet/13.png" alt="" />
              <div class="text-content">
                <span class="item-name">{{ $t("case_diabetes") }}</span>
                <span class="item-desc">{{ $t("case_diabetes_desc") }}</span>
                <span class="item-desc">{{ $t("case_diabetes_ref") }}</span>
              </div>
            </div>
          </div>
        </div>
        <button class="nav-button right-button" @click="scrollRight">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="20" cy="20" r="20" fill="#85061B" fill-opacity="0.8" />
            <path
              d="M15 20L25 20M25 20L20 15M25 20L20 25"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
    <div class="part-05">
      <div
        class="part-container right-wrapper part-05-container part-05-mobile-layout"
      >
        <div class="part-05-mobile-tag tag mobile-show">
          {{ $t("solutions") }}
        </div>
        <div class="part-05-mobile-tabs">
          <div
            class="part-05-mobile-tab"
            :class="{ red: active == '01', gray: active != '01' }"
            @click="active = '01'"
          >
            <span class="item-name">{{ $t("site_layout") }}</span>
          </div>
          <div
            class="part-05-mobile-tab"
            :class="{ red: active == '02', gray: active != '02' }"
            @click="active = '02'"
          >
            <span class="item-name">{{ $t("workstation_1plus1") }}</span>
          </div>
        </div>
        <div class="part-left part-05-left">
          <div class="item-row" @click="active = '01'">
            <div class="tag">{{ $t("solutions") }}</div>
            <div
              class="item"
              :class="{ red: active == '01', gray: active != '01' }"
            >
              <span class="item-name">{{ $t("site_layout") }}</span>
            </div>
          </div>
          <div class="item-row" @click="active = '02'">
            <div
              class="item"
              :class="{ red: active == '02', gray: active != '02' }"
            >
              <span class="item-name">{{ $t("workstation_1plus1") }}</span>
            </div>
          </div>
        </div>
        <div class="part-right part-05-right" v-show="active == '01'">
          <div class="item-row part-05-content">
            <div class="item white part-05-img-item">
              <img src="@/assets/images/pet/pet.png" class="part-05-img" />
            </div>
          </div>
        </div>
        <div class="part-right part-05-right" v-show="active == '02'">
          <div class="item-row part-05-content">
            <div class="item white part-05-row-item">
              <img src="@/assets/images/pet/03.png" class="part-05-thumb" />
              <div class="part-05-text"  :class="{ 'english-text-optimize': $i18n.locale === 'en' }">
                <span class="item-name">{{ $t("raypni_platform") }}</span>
                <span class="item-name part-05-sub">{{
                  $t("raypni_desc")
                }}</span>
              </div>
            </div>
            <div class="item white part-05-row-item">
              <img src="@/assets/images/pet/04.png" class="part-05-thumb" />
              <div class="part-05-text"  :class="{ 'english-text-optimize': $i18n.locale === 'en' }">
                <span class="item-name">{{ $t("rayplus_platform") }}</span>
                <span class="item-name part-05-sub">{{
                  $t("rayplus_desc")
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      calculatedTopHeight: 0,
      active: "01",
    };
  },
  mounted() {
    this.calculateBackgroundHeight();
    window.addEventListener("resize", this.calculateBackgroundHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateBackgroundHeight);
  },
  methods: {
    calculateBackgroundHeight() {
      this.$nextTick(() => {
        const bgImage = new Image();
        bgImage.src = require("@/assets/images/pet/05.png");

        bgImage.onload = () => {
          const container = document.querySelector(".page-container");
          const containerWidth = container.offsetWidth;

          const aspectRatio = bgImage.height / bgImage.width;
          const scaledBgHeight = containerWidth * aspectRatio;

          let height = scaledBgHeight - 72;
          if (window.innerWidth <= 768) {
            height = Math.max(250, Math.min(400, height));
          }
          this.calculatedTopHeight = height;
        };
      });
    },
    scrollLeft() {
      const container = this.$refs.scrollContainer;
      if (container) {
        const items = container.querySelectorAll(".item");
        const scrollLeftPos = container.scrollLeft;
        const containerWidth = container.offsetWidth;
        // 找到当前可见区域左边第一个还没完全显示的 item
        for (let i = items.length - 1; i >= 0; i--) {
          if (items[i].offsetLeft < scrollLeftPos) {
            // 滚动让这个 item 完整显示
            const targetScroll =
              items[i].offsetLeft + items[i].offsetWidth - containerWidth;
            container.scrollTo({
              left: Math.max(0, targetScroll),
              behavior: "smooth",
            });
            break;
          }
        }
      }
    },
    scrollRight() {
      const container = this.$refs.scrollContainer;
      if (container) {
        const items = container.querySelectorAll(".item");
        const scrollLeftPos = container.scrollLeft;
        const containerWidth = container.offsetWidth;
        // 找到当前可见区域右边第一个还没完全显示的 item
        for (let i = 0; i < items.length; i++) {
          if (
            items[i].offsetLeft + items[i].offsetWidth >
            scrollLeftPos + containerWidth + 1
          ) {
            // 滚动让这个 item 完整显示
            container.scrollTo({
              left: items[i].offsetLeft + items[i].offsetWidth - containerWidth,
              behavior: "smooth",
            });
            break;
          }
        }
      }
    },
  },
};
</script>

<style lang='less' scoped>
@import "@/assets/styles/views/common.less";

.page-container {
  background: url(@/assets/images/pet/05.png);
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  display: flow-root;
}

.part-05-mobile-tag,
.part-05-mobile-tabs {
  display: none !important;
}

.part-01-margin {
  margin-top: 100px;
}

.left-big-img-top-right {
  object-fit: contain;
  object-position: top right;
}

.tag-float {
  display: none;
}

.tag-inline {
  margin-right: -10px;
}

.part-02-container {
  height: 400px;
}

.part-02-row {
  gap: 10px;
}

.part-03-container {
  height: 500px;
}

.part-03-left {
  width: auto;
}

.part-03-img {
  height: 100%;
  width: 100%;
  object-fit: contain;
  object-position: top;
}

.part-03-right {
  margin-left: -2px;
}

.part-04-container {
  height: 500px;
  position: relative;
}

.part-05-container {
  height: 700px;
}

.part-05-deco {
  width: 400px;
  height: 400px;
}

.part-05-left {
  z-index: 100;
  margin-left: 75px;
  width: auto;
}

.part-05-right {
  z-index: 1;
  flex: auto;
}

.part-05-content {
  display: flex;
  flex-direction: column;
  width: 75%;
}

.part-05-img-item {
  width: 100%;
  height: 700px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 80px;
}

.part-05-img {
  max-height: 100%;
  width: auto;
}

.part-05-row-item {
  width: 100%;
  height: 350px;
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.part-05-thumb {
  max-height: 100%;
  width: 300px;
}

.part-05-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 14px;

  .item-name {
    font-size: 14px;
  }

  &.english-text-optimize {
      .item-name {
        font-size: 13px;
        line-height: 1.3;
        word-break: break-word;
      }
      
      .part-05-sub {
        font-size: 12px;
        line-height: 1.3;
        margin-top: 4px;
      }
    }
}

.part-05-sub {
  font-size: 14px;
}

.top {
  margin: 0 auto;
  position: relative;

  .info {
    display: flex;
    gap: 20px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    font-size: 60px;
    color: #fff;
    position: absolute;
    top: 30%;

    span {
      transition: transform 0.3s ease, color 0.3s ease;
      cursor: pointer;
      display: inline-block;
    }

    span:hover {
      transform: scale(1.05);
      color: white;
    }
  }
}

.part-02 .item {
  justify-content: center;
  align-items: center;

  .item-name {
    color: rgb(133 6 27);
    font-size: 18px;
  }

  .item-desc {
    color: rgb(1 1 1);
    text-align: center;
  }
}

.part-04 {
  margin-top: 100px;

  > .part-container {
    > .tag {
      position: absolute;
      left: 0;
      top: 0;
      width: 75px;
      height: 75px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 26px;
      background-color: rgb(244 229 232);
      z-index: 100;
    }
  }

  .scroll-container {
    width: 100%;
    height: 100%;
    position: relative;
    padding-left: 75px;
  }

  .scroll-content {
    display: flex;
    gap: 0;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }

    .item {
      flex-shrink: 0;
      width: 40%;
      height: 500px;
      font-size: 14px;
      text-align: left;
      z-index: 100;
      padding: 30px 20px;
      display: flex;
      flex-direction: column;
      gap: 5px;
      overflow: hidden;
      transition: all 0.3s ease;

      .text-content {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
          display: none;
        }

        .item-name {
          font-weight: 500;
          margin-bottom: 10px;
          transition: transform 0.3s ease;
          display: block;
        }

        .item-desc {
          display: block;
          margin-bottom: 8px;
          line-height: 1.5;
        }
      }

      .item-name {
        font-weight: 500;
        margin-bottom: 10px;
        transition: transform 0.3s ease;
      }

      img {
        transition: transform 0.3s ease;
        object-fit: contain;
        height: 60%;
        object-position: left;
      }

      &.white {
        background-color: rgb(243 243 243);
        color: rgb(1 1 1);
      }

      &.white:hover {
        transform: translateY(0px);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

        img {
          transform: scale(1);
        }

        .item-name {
          transform: scale(1);
        }
      }
    }
  }

  .nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    z-index: 101;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    padding: 0;
    display: none;

    &:hover {
      transform: translateY(-50%) scale(1.1);
    }

    &.left-button {
      left: 85px;
    }

    &.right-button {
      right: 10px;
    }
  }

  &:hover {
    .nav-button {
      display: block;
    }
  }
}

.part-05 {
  margin-top: 100px;
  margin-bottom: 100px;

  .part-left {
    width: 20%;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;

    .item-row {
      position: relative;
      .tag {
        position: absolute;
        top: 0;
        left: -75px;
      }
    }
    .item {
      width: 200px;
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      transition: transform 0.3s ease, box-shadow 0.3s ease;

      &:hover {
        transform: scale(1.05);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
      }
    }
  }
}

#app[lang="en"] {
  .tag {
    font-size: 16px;
    width: 120px;
  }
  .part-04 .tag {
    left: -45px;
  }
  .part-05 .tag {
    left: -120px;
  }
  .item {
    gap: 0;
    padding: 20px 18px;
  }
  .item-name {
    line-height: 30px;
  }
}

@media (max-width: 768px) {
  .page-container {
    background-size: auto 300px;
  }

  .top {
    .info {
      position: relative;
      top: auto;
      padding: 20px 15px;
      font-size: 24px;
      gap: 10px;
    }
  }

  .mobile-hide {
    display: none !important;
  }

  .part-01-margin {
    margin-top: 0;
  }

  .left-big-img-top-right {
    object-position: top center;
    object-fit: cover !important;
  }

  .tag-float {
    position: relative;
    top: auto;
    left: auto;
    width: 60px;
    height: 60px;
    font-size: 18px;
    letter-spacing: 3px;
    word-break: break-word;
    display: flex;
  }

  .tag-inline {
    margin-right: 0;
    width: 60px;
    height: 60px;
    font-size: 18px;
    letter-spacing: 3px;
    word-break: break-word;
  }

  .part-01 {
    .part-container {
      height: auto;
    }

    .right-big-img.mobile-hide,
    .part-left,
    .part-right {
      width: 100%;
    }

    .item-row {
      flex-wrap: wrap;
    }

    .tag {
      left: 0 !important;
    }
  }

  .part-02 {
    margin-top: 30px;
    .part-item {
      justify-content: flex-start;
    }
  }

  .part-02-container {
    height: auto;
    padding: 0 15px;
  }

  .part-02-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    .part-item {
      justify-content: flex-start;
    }

    .item {
      width: 100%;
      min-height: 80px;
      justify-content: flex-start;
      align-items: flex-start;

      .item-name {
        text-align: left;
      }

      .item-desc {
        text-align: left;
      }
    }
  }

  .part-03-container {
    height: auto;
  }

  .part-03-left {
    width: 100%;
    order: -1;
  }

  .part-03-img {
    height: auto;
    max-height: 300px;
  }

  .part-03-right {
    margin-left: 0;
    width: 100%;
  }

  .part-03 {
    .part-container {
      height: auto;
    }

    .part-left,
    .part-right {
      width: 100%;
      padding: 0 15px;
    }

    .item-row {
      flex-wrap: wrap;
    }

    .tag {
      left: 0 !important;
    }
  }

  .part-04 {
    margin-top: 50px;

    > .part-container > .tag {
      position: relative;
      width: 60px;
      height: 60px;
      font-size: 18px;
      letter-spacing: 3px;
      word-break: break-word;
      left: 15px;
    }

    .scroll-container {
      padding-left: 0;
    }

    .scroll-content .item {
      width: 85%;
      height: auto;
      min-height: 200px;

      img {
        height: 300px;
        width: auto;
      }
    }

    .nav-button {
      width: 44px;
      height: 44px;
      display: block;

      &.left-button {
        left: 5px;
      }
      &.right-button {
        right: 5px;
      }
    }
  }

  .part-05 {
    margin-top: 50px;
    margin-bottom: 50px;

    .part-container {
      flex-direction: column;
      height: auto;
    }

    .part-05-deco {
      display: none;
    }

    .part-05-mobile-tag {
      display: flex !important;
      align-items: center;
      justify-content: center;
      background-color: rgb(244 229 232);
      position: relative;
      left: 15px;
      width: 60px;
      height: 60px;
      font-size: 18px;
      letter-spacing: 3px;
      word-break: break-word;
      margin-bottom: 20px;
    }

    .part-05-mobile-tabs {
      display: flex !important;
      flex-direction: row;
      gap: 10px;
      margin-bottom: 20px;
      padding: 0 15px;

      .part-05-mobile-tab {
        padding: 10px 20px;
        min-height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s ease;

        .item-name {
          font-size: 16px;
        }

        &.red {
          background-color: rgb(133 6 27);
          color: #fff;
        }
        &.gray {
          background-color: rgb(77 77 77);
          color: #fff;
        }
      }
    }

    .part-05-left {
      display: none;
    }

    .part-05-right {
      width: 100%;
      padding: 0 15px;
    }

    .part-05-content {
      width: 100%;
      flex-direction: column;
    }

    .part-05-img-item {
      width: 100%;
      height: auto;
      padding: 15px;
    }

    .part-05-img {
      max-height: 300px;
      height: auto;
      width: auto;
    }

    .part-05-row-item {
      width: 100%;
      height: auto;
      min-height: 80px;
      flex-direction: column;
      align-items: center;
      gap: 15px;
    }

    .part-05-thumb {
      height: auto;
      width: auto;
      object-fit: contain;
    }

    .part-05-text {
      padding: 0;
      flex: 1;
    }
  }

  #app[lang="en"] .tag {
    letter-spacing: 1px !important;
  }

  /* 所有tag left设置为15px */
  .tag {
    left: 15px !important;
  }
}
</style>